<div class="row">
  <div class="col-12">
    <table class="table">
      <thead>
        <tr>
          <th scope="col" class="text-uppercase border-top-none text-left">Fecha</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Cuota</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Capital</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Interés</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Otros</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="rubrosLista?.length === 0">
          <td colspan="6" class="text-uppercase text-center">No hay información para mostrar</td>
        </tr>
        <tr *ngFor="let rubro of rubrosLista">
          <td class="text-left">{{rubro?.fecha}}</td>
          <td class="text-right">{{rubro?.cuota}}</td>
          <td class="text-right">{{rubro?.capital | currency}}</td>
          <td class="text-right">{{rubro?.interes | currency}}</td>
          <td class="text-right">{{rubro?.otros| currency}}</td>
          <td class="text-right">{{rubro?.total | currency}}</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between p-2">
      <ngb-pagination [collectionSize]="cantidad" [(page)]="pagina" [pageSize]="paginaTamanio" [rotate]="true"
        [maxSize]="5" [boundaryLinks]="true" (pageChange)="ListaRubros()">
      </ngb-pagination>

      <select class="custom-select" style="width: auto" [(ngModel)]="paginaTamanio" (ngModelChange)="ListaRubros()">
        <option [ngValue]="3">3 rubros por página</option>
        <option [ngValue]="5">5 rubros por página</option>
        <option [ngValue]="10">10 rubros por página</option>
      </select>
    </div>
  </div>
</div>
